import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form } from 'react-bootstrap';
import FormPage from '../components/FormPage';
import FormCard from '../components/FormCard';
import FormField from '../components/FormField';
import FormActions from '../components/FormActions';
import CategoryMultiSelect from '../components/CategoryMultiSelect';
import { categoryService } from '../services/categoryService';
import { useTranslation } from '../contexts/LocaleContext';
import { ROUTES } from '../constants';

const CategoryCreate: React.FC = () => {
  const t = useTranslation();
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [parentId, setParentId] = useState<number | undefined>();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await categoryService.createCategory({
        name,
        parentCategoryId: parentId || undefined,
      });
      navigate(ROUTES.CATEGORIES);
    } catch (error) {
      console.error('Error creating category:', error);
      alert(t('errors.createCategory'));
    }
  };

  return (
    <FormPage title={t('category.create')} helperContent={t('helpers.category.title')} backFallbackRoute={ROUTES.CATEGORIES}>
      <Form onSubmit={handleSubmit}>
        <FormCard>
          <FormField label={t('formField.name')} htmlFor="name" helper={t('helpers.category.name')}>
            <Form.Control
              type="text"
              name="name"
              id="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </FormField>
          <FormField label={t('formField.parent')} htmlFor="parentCategory" helper={t('helpers.category.parentCategory')}>
            <CategoryMultiSelect
              value={parentId !== undefined ? [parentId] : []}
              onChange={(ids) => setParentId(ids[0])}
              mode="only"
              height="auto"
              maxHeight="200px"
            />
          </FormField>
          <FormActions submitLabel={t('manage.save')} backTo={ROUTES.CATEGORIES} backLabel={t('categories')} />
        </FormCard>
      </Form>
    </FormPage>
  );
};

export default CategoryCreate;
